// extracted by mini-css-extract-plugin
export var emptyState = "_4o-d";
export var statCard = "_4o-c";
export var table = "_4o-0";
export var tableCell = "_4o-4";
export var tableCellClickable = "_4o-5 _4o-4";
export var tableCellDefault = "_4o-6 _4o-4";
export var tableCellEmpty = "_4o-8";
export var tableCellWithValue = "_4o-7";
export var tableContainer = "_4o-e";
export var tableHeaderWeight = "_4o-1";
export var tableHeaderZone = "_4o-2";
export var tableRowHeader = "_4o-3";
export var viewModeButton = "_4o-9";
export var viewModeButtonActive = "_4o-a _4o-9";
export var viewModeButtonInactive = "_4o-b _4o-9";